export const BRAND = {
  PORTAL_NAME: 'perpetual',
  NAME: 'Perpetual',
  LOGO: '/images/brand/Logo.svg',
  LOGO_LINK: '',
  LOGIN_BG_IMAGE: '',
  SUPPORT_EMAIL: '',
  MARKET_SITE: '',
};

export const SocketEnds = {
  SOCKET_TOKEN: '/v1/socket-token',
};

export const NotificationEnds = {
  NOTIFICATION_LIST: (
    read: string,
    archive: string,
    filter: string,
    actionFilter: string
  ) =>
    `v1/notifications?read=${read}&archived=${archive}&filter=${filter}&actionFilter=${actionFilter}`,
  UPDATE_NOTIFICATION: (id: string) => `v1/notifications/${id}`,
  DELETE_NOTIFICATION: (id: string) => `v1/notifications/${id}`,

  UPDATE_NOTIFICATION_SETTING: '/v1/notifications/settings/modules',
  GET_ALL_NOTIFICATION_SETTINGS: '/v1/notifications/settings',
};

export const RestEnds = {
  // Authentication
  LOGIN: '/v1/userLogin',
  ORG_LIST: '/v1/organization',
  OGR_ACCESS_TOKEN: '/v1/orgAuthToken',
  SSO_LOGIN: '/v1/sso/login',

  LOGOUT: '/v1/logout',
  REFRESH_TOKEN: '/v1/refreshToken',

  INVITE_DETAIL: (id: string) => `/v1/invitation?id=${id}`,
  ACCEPT_INVITE_DETAIL: '/v1/accept_invitation',
  FORGET_PASSWORD: (email: string) => `/v1/password-reset/mail?email=${email}`,
  RESET_PASSWORD: (token: string, password: string) =>
    `/v1/password-reset?token=${token}&newPassword=${password}`,
  VALID_TOKEN: (token: string) => `/v1/password-reset/token?token=${token}`,

  SEND_OTP: '/v1/2fa/email-otp',
  TWO_FA_LOGIN: '/v1/2fa/login',
};

export const DatasetEnds = {
  GET_DATASET: (queryString: string) => `/v1/datasets?${queryString}`,
  GET_SINGLE_DATASET: `/v1/datasets`,
  CREATE_DATASET: '/v1/datasets',
  UPDATE_DATASET: (id: string) => `/v1/datasets/${id}`,
  DELETE_DATASET: (id: string) => `/v1/datasets/${id}`,
  UPDATE_DATASET_STATUS: (id: string, status: string) =>
    `v1/datasets?id=${id}&status=${status}`,
  GET_HISTORY: (entityType: string, entityId: string) =>
    `v1/history/${entityType}/${entityId}`,

  BULK_UPLOAD: '/v1/datasets/bulkUpload',
};

export const AISystemEnds = {
  POST_AISOLUTIONS: '/v1/ai-systems',
  GET_AISOLUTIONS: (queryString: string) => `/v1/ai-systems?${queryString}`,
  AISOLUTIONS_DETAIL: (id: string) => `/v1/ai-systems/${id}`,
  LINK_DATASET: (id: string) => `/v1/ai-systems/${id}/dataset`,
  UPDATE_AISOLUTIONS: (id: string) => `/v1/ai-systems/${id}`,
  DELETE_AISOLUTIONS: (id: string) => `/v1/ai-systems/${id}`,
  UPDATE_AISOLUTIONS_STATUS: (id: string, status: string) =>
    `v1/ai-systems?id=${id}&status=${status}`,
  GET_FEEDBACK: (id: string) => `/v1/feedback?id=${id}`,
  UPDATE_FEEDBACK: (id: string, isReviewd: boolean) =>
    `/v1/feedback?id=${id}&isReviewd=${isReviewd}`,
  AI_SUMMARY: '/v1/ai-system/metrics',
  POST_COMMENT: '/v1/comments',
  GET_COMMENTS: (entityType: string, entityId: string) =>
    `/v1/comments/${entityType}/${entityId}`,
  UPDATE_COMMENT: (commentId: string) => `/v1/comments/${commentId}`,
  DELETE_COMMENT: (commentId: string) => `/v1/comments/${commentId}`,
  BULK_UPLOAD: `/v1/ai-system/bulkUpload`,
  TOOLS: '/v1/tools',
  GET_TOOLS: (id: string) => `/v1/tools/${id}`,
  DELETE_TOOL: (id: string) => `/v1/tools/${id}`,
  AI_APPROVAL_GATE_BY_ID: (id: string) => `v1/ai-approval-gates/${id}`,
  AI_CREATE_UPDATE_APPROVAL_GATE: 'v1/ai-approval-gates',
  GET_HISTORY_AISYSTEM_TEVV: (id: string) => `v1/history/AISystem-tevv/${id}`,
  GET_HISTORY_AISYSTEM_SYSTEM_FAILURE: (id: string) =>
    `v1/history/AISystem-system-failure/${id}`,
};

export const TrainingProgramEnds = {
  TRAINING_TEMPLATE: '/v1/training-template',
  TRAINING_TEMPLATE_ID: (id: string) => `/v1/training-template/${id}`,
  CREATE_TRAINING_PROGRAMS: '/v1/training-programs',
  TRAINING_PROGRAMS: (queryString: string) =>
    `/v1/training-programs?${queryString}`,
  TRAINING_PROGRAM_ID: (id: string) => `/v1/training-programs/${id}`,

  // Assignments
  CREATE_ASSIGNMENT: '/v1/training-assignment',
  GET_ASSIGNMENTS: (id: string) => `/v1/training-assignment/program/${id}`,
  RESEND_REMINDER_ASSIGNMENTS: (id: string) =>
    `/v1/training-assignment/reminder/${id}`,
  UPDATE_ASSIGNMENTS: (id: string) => `/v1/training-assignment/${id}`,
  GET_PROGRESS_ASSIGNMENT: (id: string) => `/v1/training-assignment/${id}`,

  // AI Systems
  LINK_AI_SYSTEM: (id: string) => `/v1/training-programs/${id}/ai-systems`,
  TRAINING_TOKEN: (id: string) => `/v1/public/trainingtoken?id=${id}`,
};

export const SensitivityEnds = {
  CREATE: '/v1/sensitivity-types',
  GET_ALL: '/v1/sensitivity-types',
  DELETE: (id: string) => `/v1/sensitivity-types/${id}`,
  UPDATE: (id: string) => `/v1/sensitivity-types/${id}`,
};

export const RiskRegisterEnds = {
  CREATE: '/v1/risk',
  GET_ALL: (queryString: string) => `/v1/risk?${queryString}`,
  DETAIL: (id: string) => `/v1/risk/${id}`,
  UPDATE: (id: string) => `/v1/risk/${id}`,
  LINK_AI_SYSTEM: (id: string) => `/v1/risk/${id}/ai-systems`,
  LINK_DATASET: (id: string) => `/v1/risk/${id}/dataset`,
  DELETE: (id: string) => `/v1/risk/${id}`,
};

export const RiskOverviewEnds = {
  GET_ALL: (filterType: any, aiFilter: any, fromDate: any, toDate: any) =>
    `/v1/riskoverview?filterType=${filterType}&aiFilter=${aiFilter}&fromDate=${fromDate}&toDate=${toDate}`,
};

export const TierApproverEnds = {
  CREATE: '/v1/risk-tier-approvers',
  GET_ALL: '/v1/risk-tier-approvers',
  DELETE: (id: string) => `/v1/risk-tier-approvers/${id}`,
  USER_TIER: '/v1/user/tier',
};

export const VulnerabilityEnds = {
  CREATE: '/v1/vulnerabilities',
  UPDATE: (id: string) => `/v1/vulnerabilities/${id}`,
  GET_DETAIL: (id: string) => `/v1/vulnerabilities/${id}`,
  GET_ALL: (queryString: string) => `/v1/vulnerabilities?${queryString}`,
  DELETE: (id: string) => `/v1/vulnerabilities/${id}`,
  BULK_UPDATE_STATUS: '/v1/vulnerabilities/status',
  BULK_UPLOAD: '/v1/vulnerabilities/bulk',

  // AI System and Dataset
  LINK_AI_SYSTEM: (id: string) => `/v1/vulnerabilities/${id}/ai-systems`,
  LINK_DATASET: (id: string) => `/v1/vulnerabilities/${id}/dataset`,
  LINK_INCIDENT: (id: string) => `/v1/vulnerabilities/${id}/incident`,
  LINK_RISK: (id: string) => `/v1/vulnerabilities/${id}/risk`,

  // VULNERABILITY DASHBOARD
  DASHBOARD: '/v1/vulnerability/dashbaord',
};

export const PoliciesEnds = {
  CREATE: '/v1/policy',
  GET_ALL: (queryString: string) => `/v1/policy?${queryString}`,
  DELETE: (id: string) => `/v1/policy/${id}`,
  DETAIL: (id: string) => `/v1/policy/${id}`,
  UPDATE: (id: string) => `/v1/policy/${id}`,
  GET_POLICY_VERSION: (id: string) =>
    `/v1/policy_versions/${id}?includeDiff=true`,

  // Acknowledgements
  CREATE_ACK: '/v1/acknowledgement',
  GET_ACK_LIST: (id: string) => `/v1/acknowledgement/${id}`,
  ACK_POLICY: (id: string) => `/v1/acknowledgement/${id}`,
  DELETE_ACK_POLICY: (id: string) => `/v1/acknowledgement/${id}`,
  POLICY_BY_ACK_ID: (id: string) => `/v1/acknowledgementPolicy/${id}`,

  // Approvals
  ADD_APPROVER: '/v1/policy_approval',
  APPROVERS: (id: string) => `/v1/policy_approval/?id=${id}`,
  DELETE_APPROVER: (id: string) => `/v1/policy_approval/?id=${id}`,
  APPROVE_POLICY: (id: string) => `/v1/approve/?id=${id}`,
  APPROVAL_GATES: '/v1/approval-gates',
  APPROVAL_GATES_BY_ID: (id: string) => `/v1/approval-gates/${id}`,
  ADD_APPROVAL_GATE: '/v1/approval-gates',
  DELETE_APPROVAL_GATE: (id: string) => `/v1/approval-gates/${id}`,
  UPDATE_APPROVAL_GATE: (id: string) => `/v1/approval-gates/${id}`,

  // Review
  REVIEW_POLICY: (id: string) => `/v1/policy-review/${id}`,
  REVIEW_HISTORY: (id: string) => `/v1/policy-review/${id}`,

  // Compliance Policy Templates
  COMPLIANCE_POLICY_TEMPLATES: `/v1/compliance/framework`,
  ADD_POLICY_FRAMEWORK: (id: string) => `/v1/policy/${id}/framework`,
  POLICY_COMPLIANCES_TRACKING: '/v1/compliance/complianceframework',
  CREATE_COMPLIANCES_TRACKING: '/v1/compliance-tracking',
  UPDATE_COMPLIANCES_TRACKING: (id: string) => `/v1/compliance-tracking/${id}`,
  GET_COMPLIANCES_TRACKING: '/v1/compliance-tracking',
  HEALTH_CHECK: (healthId: string) => `/v1/policy/healthcheck?id=${healthId}`,
  CREATE_COMPLIANCES_ATTACHMENT: '/v1/compliance-attachment',
  DELETE_COMPLIANCES_ATTACHMENT: (id: string) =>
    `/v1/compliance-attachment/${id}`,
  COMPLIANCES_ATTACHMENT_DOWNLOAD: (id: string) =>
    `/v1/compliance-attachment/download/${id}`,
};

export const GuardrailsEnds = {
  // Guardrail Packages
  GET_ALL_PACAKGES: '/v1/guardrails/package',
  CREATE_PACKAGE: '/v1/guardrails/package',
  UPDATE_PACKAGE: (id: string) => `/v1/guardrails/package/${id}`,
  DELETE_PACKAGE: (id: string) => `/v1/guardrails/package/${id}`,

  // Guardrail Policy
  GET_ALL_POLICIES: '/v1/guardrails/policy',
  CREATE_POLICY: '/v1/guardrails/policy',
  UPDATE_POLICY: (id: string) => `/v1/guardrails/policy/${id}`,
  DELETE_POLICY: (id: string) => `/v1/guardrails/policy/${id}`,

  // Guardrail groups
  GET_ALL_GROUPS: '/v1/guardrails/group',
  GET_ALL_GROUP_WITH_POLICIES: '/v1/guardrails/group/policy',

  CREATE_GROUP: '/v1/guardrails/group',
  DELETE_GROUP: (id: string) => `/v1/guardrails/group/${id}`,

  GET_MCP_PROXY: '/v1/guardrails/mcp-proxy',

  // Tools Governance
  GET_ALL_TOOLS: (serverId: string) =>
    `v1/guardrails/tools?serverId=${serverId}`,
  CREATE_TOOL: '/v1/guardrails/tools',
  DELETE_TOOL: (id: string) => `/v1/guardrails/tools/${id}`,

  // api-key
  GET_API_KEYS: '/v1/guardrails/apikeys',
  CREATE_API_KEY: '/v1/guardrails/apikeys',
  UPDATE_API_KEY: (id: string) => `/v1/guardrails/apikeys/${id}`,
  DELETE_API_KEY: (id: string) => `/v1/guardrails/apikeys/${id}`,

  // servers
  GET_ALL_SERVERS: '/v1/guardrails/server',
  CREATE_SERVER: '/v1/guardrails/server',
  UPDATE_SERVER: (id: string) => `/v1/guardrails/server/${id}`,
  DELETE_SERVER: (id: string) => `/v1/guardrails/server/${id}`,

  // Proxy settings
  GET_PROXY_SETTINGS: '/v1/guardrails/proxy-settings',
  UPDATE_PROXY_SETTINGS: '/v1/guardrails/proxy-settings',
};

export const ManageEmployeesEnds = {
  CREATE: '/v1/employee',
  GET_ALL: (queryString: string) => `/v1/employee?${queryString}`,
  DELETE: (id: string) => `/v1/employee/${id}`,
  DETAIL: (id: string) => `/v1/employee/${id}`,
  UPDATE: (id: string) => `/v1/employee/${id}`,
  RESEND_INVITE: (id: string) => `/v1/team_member?id=${id}`,
  BULK_UPLOAD: '/v1/employee/bulkupload',
};

export const ManageTeamEnds = {
  CREATE: '/v1/team_members',
  GET_ALL: (queryString: string) => `/v1/all_invitation?${queryString}`,
  DELETE: (id: string) => `/v1/employee/${id}`,
  DETAIL: (id: string) => `/v1/employee/${id}`,
  UPDATE: (id: string) => `/v1/employee/${id}`,
  TEAM_MEMBERS: (queryString: string) => `/v1/team_members?${queryString}`,
  TEAM_MEMBERS_AUDITOR_GOVERNANCE_REVIEWER: (queryString: string) =>
    `/v1/team_members?${queryString}&role=Auditor,GovernanceReviewer`,
  DELETE_TEAM_MEMBER: (memberUserId: string) =>
    `/v1/team_member/${memberUserId}`,
};

export const ModelsEnds = {
  GET_MODELS: '/v1/models',
};

export const RiskAssessmentEnds = {
  TEMPLATES: '/v1/risk-assessment-templates',
  GET_ASSESSMENTS: '/v1/risk-assessment',
  POST_ASSESSMENT: '/v1/risk-assessment',
  POST_ASSESSMENT_RESPONSE: '/v1/risk-assessment',
  LINKED_ASSESSMENTS: '/v1/risk-assessment',
  CREATE_TEMPLATE: 'v1/risk-assessment-templates',
  UPDATE_TEMPLATE: (id: string) => `v1/risk-assessment-templates/${id}`,
  GET_CUSTOM_TEMPLATES: (queryString: string) =>
    `/v1/risk-assessment-templates/custom?${queryString}`,
  GET_CUSTOM_TEMPLATE_BY_ID: (id: string) =>
    `/v1/risk-assessment-templates/custom/${id}`,
  DELETE_TEMPLATE_BY_ID: (id: string) => `/v1/risk-assessment-templates/${id}`,

  // External Assessment
  SEND_ASSESSMENT: '/v1/risk-assessment',
  GET_EXTERNAL_ASSESSMENTS: (queryParams: string) =>
    `/v1/risk-assessment?${queryParams}`,
  GET_EXTERNAL_ASSESSMENTS_STATS: '/v1/external/risk-assessment/stats',
  DELETE_ASSESSMENT_BY_ID: (id: string) => `/v1/risk-assessment/${id}`,
  GET_EXTERNAL_AUTH: '/v1/external/risk-assessment/auth',
  GET_EXTERNAL_ASSESSMENT_DETAIL: (id: string) =>
    `/v1/external/risk-assessment/id/${id}`,
  GET_GUEST_EXTERNAL_ASSESSMENT_DETAIL: `/v1/external/risk-assessment/guest/id`,
  COMPLETE_EXTERNAL_ASSESSMENT_DETAIL: '/v1/external/risk-assessment/fill',
};

export const IncidentEnds = {
  CREATE: '/v1/incidents',
  GET_ALL: (queryString: string) => `/v1/incidents?${queryString}`,
  UPDATE: (id: string) => `/v1/incidents/${id}`,
  DELETE: (id: string) => `/v1/incidents/${id}`,
  DETAIL: (id: string) => `/v1/incidents/${id}`,
  // History
  UPDATE_STATUS: `/v1/incident-history`,
  INCIDENT_HISTORY: (id: string) => `/v1/incident-history/${id}`,

  // AI System and Dataset
  LINK_AI_SYSTEM: (id: string) => `/v1/incidents/${id}/ai-systems`,
  LINK_DATASET: (id: string) => `/v1/incidents/${id}/dataset`,
  ASSIGN_INCIDENT: (id: string) => `/v1/incidents/assigneuser/${id}`,

  // GET_ALL_DASHBOARD: '/v1/incident/dashboard',
  GET_ALL_DASHBOARD: (filterType: any, fromDate: any, toDate: any) =>
    `/v1/incident/dashboard?filterType=${filterType}&fromDate=${fromDate}&toDate=${toDate}`,
};

export const TevvEnds = {
  GET_FILE_DETAILS: (templatesId: string) =>
    `/v1/tevv-templates?id=${templatesId}`,
  UPLOAD_FILE: (templatesId: string) => `/v1/tevv-templates?id=${templatesId}`,
  DELETE_FILE: (templatesId: string, fieldId: string) =>
    `/v1/tevv-templates?tempId=${templatesId}&fileId=${fieldId}`,
  GET_FILE: (fileId: string) => `/v1/tevv-fileDetails?id=${fileId}`,
  DOWNLOAD_FILE: (templatesId: string, fileId: string) =>
    `/v1/tevv-file?tempId=${templatesId}&fileId=${fileId}`,
};

export const EnterpriseEnds = {
  GET_ENTERPRISE_TOKEN: (expiryDays: number) =>
    `/v1/enterprise/token?expiryDays=${expiryDays}`,
  GET_TOKEN_LIST: '/v1/enterprise/token',
  DELETE_TOKEN: (id: string) => `/v1/enterprise/token?id=${id}`,
};

export const PublicEnds = {
  GET_POLICY: '/v1/policy',
  GET_ACCESS_TOKEN: (token: string) => `v1/publicAccessToken?token=${token}`,
  GET_DATA_SETS: (status: string) => `/v1/datasets?approvalstatus=${status}`,
  GET_AI_SYSTEM: (status: string) => `/v1/ai-systems?approvalstatus=${status}`,
  GET_FEEDBACK_TYPES: '/v1/feedback-types',
  UPDATE_FEEDBACK: '/v1/feedback',
  SUBMIT_AI_SYSTEM: '/v1/ai-systems',
};

export const PublicSumbissionEnds = {
  SUBMISSION_LIST: '/v1/public/ai-system',
  APPROVE_SUBMISSION: (id: string, status: string) =>
    `/v1/public/ai-system?id=${id}&status=${status}`,
  CONVERT_SUBMISSION: (id: string) =>
    `/v1/public/ai-system/convert?id=${id}&status=true`,
};

export const DiscoverAIEnds = {
  CREATE: '/v1/discover-ai/creds',
  GET_ALL: (connectionType: string) =>
    `/v1/discover-ai/creds?connectiontype=${connectionType}`,
  DELETE: (id: string) => `/v1/discover-ai/creds?id=${id}`,
  GIT_REPOS: (id: string) => `/v1/discover-ai/git?id=${id}`,
  HUGGING_MODELS: (search: string, connectionId: string) =>
    `v1//discover-ai/huggingface-models?search=${search}&connectionId=${connectionId}`,
  IMPORT_HUGGING_FACE: 'v1/discover-ai/hfmodel',
  IMPORT_History: (connectionId: string) =>
    `/v1/discover-ai/huggingface/imports?connectionId=${connectionId}`,
};

export const MCPServersEnds = {
  CREATE: '/v1/mcp-servers',
  GET_ALL: (queryString: string) => `/v1/mcp-servers?${queryString}`,
  GET_DETAILS: (id: string) => `/v1/mcp-servers/${id}`,
  UPDATE: (id: string) => `/v1/mcp-servers/${id}`,
  UPDATE_APPROVE_STATUS: (id: string) => `/v1/mcp-servers/approval/${id}`,
  DELETE_SERVER: (id: string) => `/v1/mcp-servers/${id}`,
};

export const MaturityEnds = {
  CHECK_LIST: '/v1/ai-maturity-checklist',
  STAGES: '/v1/ai-maturity-stages',
  UPDATE_CHECKLIST: '/v1/ai-maturity-response',
  GET_CHECKLIST_RESPONSE: '/v1/ai-maturity-response',
  SUMMARY: '/v1/ai-maturity-response/summary',
};

export const AIRiskBaselineEnds = {
  GET_QUESTIONNARIES: '/v1/ai_risk_questionnaries',
  CREATE_ASSESSMENT: `/v1/ai_risk_assessment_baseline`,
  GET_ASSESSMENT_ID: (id: string) => `/v1/ai_risk_assessment_baseline/${id}`,
  GET_ASSESSMENT: (status: string, page: any = 1) =>
    `/v1/ai_risk_assessment_baseline?status=${status}&page=${page}&limit=10`,
  UPDATE_ASSESSMENT: (id: string) => `/v1/ai_risk_assessment_baseline/${id}`,
  GET_AI_RISK_OVERVIEW: `/v1/ai_risk_assessment_baseline/overview`,
  DELETE: (id: string) => `/v1/ai_risk_assessment_baseline/${id}`,
  DOWNLOAD: (id: string) => `/v1/ai_risk_assessment_baseline/report/${id}`,
};

export const DashboardEnds = {
  OVERVIEW: '/v1/overview',
};

export const SettingsEnds = {
  GET_ALL_AI_USE_CATEGORIES: '/v1/ai_use_category',
  UPDATE_CATEGORY_STATUS: '/v1/ai_use_category',
  MODULE_SUMMARY: '/v1/settings/overview',
  FRESHDESK_LOGIN: '/v1/freshdesk',

  TWO_FA: '/v1/2fa/config',
  TWO_FA_SETUP: '/v1/2fa/totp-setup',
  TWO_FA_RESET: '/v1/2fa/reset',
  TWO_FA_VERIFY: '/v1/2fa/totp-verify',

  GET_ALL_REMINDERS: '/v1/reminder',
  UPDATE_REMINDERS: '/v1/reminder',
};

export const ProfileEnds = {
  CHANGE_PASSWORD: '/v1/change-password',
};

export const INTERNAL_TYPE_LABEL: any = {
  0: '',
  1: 'Internally Developed Software with Embedded AI',
  2: 'Internally Developed AI Agents / Autonomous Systems',
  3: 'Internally Developed Foundation or Reusable Models',
};

export const INTERNAL_TYPES = [
  {
    title: INTERNAL_TYPE_LABEL[1],
    description: `Custom applications built by your organisation
                              that include AI/ML capabilities embedded within
                              the software.`,
  },
  {
    title: INTERNAL_TYPE_LABEL[2],
    description: `AI agents or autonomous systems developed in-house
                            that can perform tasks with minimal human
                            intervention.`,
  },
  {
    title: INTERNAL_TYPE_LABEL[3],
    description: `Foundation models or reusable AI/ML models created
                            by your organisation for multiple applications.`,
  },
];
export const THIRD_PARTY_TYPE_LABEL: any = {
  0: '',
  1: 'Third-Party Software with AI Functionality',
  2: 'Third-Party AI Agents / Assistants',
  3: 'Third-Party Foundation or Model APIs',
  4: 'Fine-Tuned Third-Party Models',
  5: 'Multi-Agent or Composite Systems',
  6: 'AI-Enabled Hardware Devices',
};

export const THIRD_PARTY_TYPES = [
  {
    title: THIRD_PARTY_TYPE_LABEL[1],
    description: `Commercial software products from external vendors
                            that include built-in AI features and capabilities.`,
  },
  {
    title: THIRD_PARTY_TYPE_LABEL[2],
    description: `External AI agents or assistants provided by
                            third-party vendors (e.g., GitHub Copilot, ChatGPT
                            Enterprise).`,
  },
  {
    title: THIRD_PARTY_TYPE_LABEL[3],
    description: `External AI services and foundation models accessed
                            via API (e.g., OpenAI, Anthropic, Google Vertex AI).`,
  },
  {
    title: THIRD_PARTY_TYPE_LABEL[4],
    description: `Third-party AI models that have been customized or
                            fine-tuned specifically for your organisation's
                            needs.`,
  },
  {
    title: THIRD_PARTY_TYPE_LABEL[5],
    description: `Complex systems that combine multiple AI agents or
                            models working together to accomplish tasks.`,
  },
  {
    title: THIRD_PARTY_TYPE_LABEL[6],
    description: `Physical devices with built-in AI, such as Alexa,
                            Google Nest, or smart sensors.`,
  },
];

export const EXECUTIVE_TRAINING_LEADERSHIP_TRAINING_STEP = [
  {
    id: 1,
    title:
      'Intro to AI governance for boards and executives and Why it Matters',
    type: 'video',
    youtubeUrl: '',
  },
  {
    id: 2,
    title: 'Intro to AI governance for boards and executives Quiz',
    type: 'quiz',
    data: [
      {
        question:
          'Which statement best reflects why AI governance is a board-level issue?',
        answer: [
          {
            1: 'AI creates cross-enterprise exposure (legal, privacy, reputation, safety) that requires board ',
            2: 'AI risk is primarily an IT concern that can be fully delegated to security teams.',
            3: 'AI governance is only required when an organisation builds its own models.',
            4: 'AI governance matters mainly for marketing and public relations.',
          },
        ],
        explanation:
          'The deck frames AI exposure as multi-domain and enterprise-wide, requiring leadership to set expectations and require evidence—not just delegate to a single function.',
      },
      {
        question:
          'Shadow AI is best treated as a user behavior problem solved mainly through employee discipline.',
        answer: false,
        explanation:
          'The deck frames AI exposure as multi-domain and enterprise-wide, requiring leadership to set expectations and require evidence—not just delegate to a single function.',
      },
      {
        question:
          'Which set lists the primary risk domains the board should assume AI can affect?',
        answer: [
          {
            1: 'Only legal & regulatory',
            2: 'Only privacy & security',
            3: 'Legal & regulatory, privacy & security, reputation & trust, safety & consumer harm',
            4: 'Sales growth, hiring speed, and engineering velocity',
          },
        ],
        explanation:
          'The deck frames AI exposure as multi-domain and enterprise-wide, requiring leadership to set expectations and require evidence—not just delegate to a single function.',
      },
    ],
  },
  {
    id: 3,
    title: 'Governance Roles',
    type: 'video',
    youtubeUrl: '',
  },
  {
    id: 4,
    title: 'Governance Roles Quiz',
    type: 'quiz',
    data: [
      {
        question:
          'Which statement best reflects why AI governance is a board-level issue?',
        answer: [
          {
            1: 'AI creates cross-enterprise exposure (legal, privacy, reputation, safety) that requires board ',
            2: 'AI risk is primarily an IT concern that can be fully delegated to security teams.',
            3: 'AI governance is only required when an organisation builds its own models.',
            4: 'AI governance matters mainly for marketing and public relations.',
          },
        ],
        explanation:
          'The deck frames AI exposure as multi-domain and enterprise-wide, requiring leadership to set expectations and require evidence—not just delegate to a single function.',
      },
      {
        question:
          'Shadow AI is best treated as a user behavior problem solved mainly through employee discipline.',
        answer: false,
        explanation:
          'The deck frames AI exposure as multi-domain and enterprise-wide, requiring leadership to set expectations and require evidence—not just delegate to a single function.',
      },
      {
        question:
          'Which set lists the primary risk domains the board should assume AI can affect?',
        answer: [
          {
            1: 'Only legal & regulatory',
            2: 'Only privacy & security',
            3: 'Legal & regulatory, privacy & security, reputation & trust, safety & consumer harm',
            4: 'Sales growth, hiring speed, and engineering velocity',
          },
        ],
        explanation:
          'The deck frames AI exposure as multi-domain and enterprise-wide, requiring leadership to set expectations and require evidence—not just delegate to a single function.',
      },
    ],
  },
  {
    id: 5,
    title: 'Risk Appetite',
    type: 'video',
    youtubeUrl: '',
  },
  {
    id: 6,
    title: 'Risk Appetite Quiz',
    type: 'quiz',
    data: [
      {
        question:
          'Which statement best reflects why AI governance is a board-level issue?',
        answer: [
          {
            1: 'AI creates cross-enterprise exposure (legal, privacy, reputation, safety) that requires board ',
            2: 'AI risk is primarily an IT concern that can be fully delegated to security teams.',
            3: 'AI governance is only required when an organisation builds its own models.',
            4: 'AI governance matters mainly for marketing and public relations.',
          },
        ],
        explanation:
          'The deck frames AI exposure as multi-domain and enterprise-wide, requiring leadership to set expectations and require evidence—not just delegate to a single function.',
      },
      {
        question:
          'Shadow AI is best treated as a user behavior problem solved mainly through employee discipline.',
        answer: false,
        explanation:
          'The deck frames AI exposure as multi-domain and enterprise-wide, requiring leadership to set expectations and require evidence—not just delegate to a single function.',
      },
      {
        question:
          'Which set lists the primary risk domains the board should assume AI can affect?',
        answer: [
          {
            1: 'Only legal & regulatory',
            2: 'Only privacy & security',
            3: 'Legal & regulatory, privacy & security, reputation & trust, safety & consumer harm',
            4: 'Sales growth, hiring speed, and engineering velocity',
          },
        ],
        explanation:
          'The deck frames AI exposure as multi-domain and enterprise-wide, requiring leadership to set expectations and require evidence—not just delegate to a single function.',
      },
    ],
  },
  {
    id: 7,
    title: 'Oversight of High-Risk AI',
    type: 'video',
    youtubeUrl: '',
  },
  {
    id: 8,
    title: 'Oversight of High-Risk AI Quiz',
    type: 'quiz',
    data: [
      {
        question:
          'Which statement best reflects why AI governance is a board-level issue?',
        answer: [
          {
            1: 'AI creates cross-enterprise exposure (legal, privacy, reputation, safety) that requires board ',
            2: 'AI risk is primarily an IT concern that can be fully delegated to security teams.',
            3: 'AI governance is only required when an organisation builds its own models.',
            4: 'AI governance matters mainly for marketing and public relations.',
          },
        ],
        explanation:
          'The deck frames AI exposure as multi-domain and enterprise-wide, requiring leadership to set expectations and require evidence—not just delegate to a single function.',
      },
      {
        question:
          'Shadow AI is best treated as a user behavior problem solved mainly through employee discipline.',
        answer: false,
        explanation:
          'The deck frames AI exposure as multi-domain and enterprise-wide, requiring leadership to set expectations and require evidence—not just delegate to a single function.',
      },
      {
        question:
          'Which set lists the primary risk domains the board should assume AI can affect?',
        answer: [
          {
            1: 'Only legal & regulatory',
            2: 'Only privacy & security',
            3: 'Legal & regulatory, privacy & security, reputation & trust, safety & consumer harm',
            4: 'Sales growth, hiring speed, and engineering velocity',
          },
        ],
        explanation:
          'The deck frames AI exposure as multi-domain and enterprise-wide, requiring leadership to set expectations and require evidence—not just delegate to a single function.',
      },
    ],
  },
  {
    id: 9,
    title: 'Maturity Metrics',
    type: 'video',
    youtubeUrl: 3,
  },
  {
    id: 10,
    title: 'Maturity Metrics Quiz',
    type: 'quiz',
    data: [
      {
        question:
          'Which statement best reflects why AI governance is a board-level issue?',
        answer: [
          {
            1: 'AI creates cross-enterprise exposure (legal, privacy, reputation, safety) that requires board ',
            2: 'AI risk is primarily an IT concern that can be fully delegated to security teams.',
            3: 'AI governance is only required when an organisation builds its own models.',
            4: 'AI governance matters mainly for marketing and public relations.',
          },
        ],
        explanation:
          'The deck frames AI exposure as multi-domain and enterprise-wide, requiring leadership to set expectations and require evidence—not just delegate to a single function.',
      },
      {
        question:
          'Shadow AI is best treated as a user behavior problem solved mainly through employee discipline.',
        answer: false,
        explanation:
          'The deck frames AI exposure as multi-domain and enterprise-wide, requiring leadership to set expectations and require evidence—not just delegate to a single function.',
      },
      {
        question:
          'Which set lists the primary risk domains the board should assume AI can affect?',
        answer: [
          {
            1: 'Only legal & regulatory',
            2: 'Only privacy & security',
            3: 'Legal & regulatory, privacy & security, reputation & trust, safety & consumer harm',
            4: 'Sales growth, hiring speed, and engineering velocity',
          },
        ],
        explanation:
          'The deck frames AI exposure as multi-domain and enterprise-wide, requiring leadership to set expectations and require evidence—not just delegate to a single function.',
      },
    ],
  },
  {
    id: 11,
    title: 'Next Steps',
    type: 'video',
    youtubeUrl: '',
  },
  {
    id: 12,
    title: 'Next Steps Quiz',
    type: 'quiz',
    data: [
      {
        question:
          'Which statement best reflects why AI governance is a board-level issue?',
        answer: [
          {
            1: 'AI creates cross-enterprise exposure (legal, privacy, reputation, safety) that requires board ',
            2: 'AI risk is primarily an IT concern that can be fully delegated to security teams.',
            3: 'AI governance is only required when an organisation builds its own models.',
            4: 'AI governance matters mainly for marketing and public relations.',
          },
        ],
        explanation:
          'The deck frames AI exposure as multi-domain and enterprise-wide, requiring leadership to set expectations and require evidence—not just delegate to a single function.',
      },
      {
        question:
          'Shadow AI is best treated as a user behavior problem solved mainly through employee discipline.',
        answer: false,
        explanation:
          'The deck frames AI exposure as multi-domain and enterprise-wide, requiring leadership to set expectations and require evidence—not just delegate to a single function.',
      },
      {
        question:
          'Which set lists the primary risk domains the board should assume AI can affect?',
        answer: [
          {
            1: 'Only legal & regulatory',
            2: 'Only privacy & security',
            3: 'Legal & regulatory, privacy & security, reputation & trust, safety & consumer harm',
            4: 'Sales growth, hiring speed, and engineering velocity',
          },
        ],
        explanation:
          'The deck frames AI exposure as multi-domain and enterprise-wide, requiring leadership to set expectations and require evidence—not just delegate to a single function.',
      },
    ],
  },
  {
    id: 13,
    title: 'Congratulations',
    type: 'video',
    youtubeUrl: '',
  },
];

export const BROADCAST_MESSAGES = {
  RELOAD_SENSITIVITY: 'RELOAD_SENSITIVITY',
  RELOAD_ASSESSMENTS: 'RELOAD_ASSESSMENTS',
  RELOAD_TRAINING_ASSIGNMENTS: 'RELOAD_TRAINING_ASSIGNMENTS',
  RELOAD_POLICY_REVIEWS: 'RELOAD_POLICY_REVIEWS',
  RELOAD_POLICY_DETAILS: 'RELOAD_POLICY_DETAILS',
  RELOAD_MATURITY_SUMMARY: 'RELOAD_MATURITY_SUMMARY',
  RELOAD_AI_SYS_DETAIL: 'RELOAD_AI_SYS_DETAIL',
  RELOAD_AI_DOCUMENT_LIST: 'RELOAD_AI_DOCUMENT_LIST',
};

export const ROLES = [
  'AI Engineer',
  'Data Scientist',
  'Product Manager',
  'Software Engineer',
  'DevOps Engineer',
  'Quality Assurance',
  'Business Analyst',
  'Executive Leadership',
  'Legal Counsel',
  'Compliance Officer',
  'Risk Manager',
  'Board Members',
  'C-Suite',
];
